export default __webpack_public_path__ + "static/media/WOR-metaphor1.d13c4b0f.png";